export default __webpack_public_path__ + "static/media/blackslider1.480dedea.png";